module.exports = __webpack_public_path__ + "static/media/sunny-profile.57801c08.jpg";